<!-- <div class="row">
  <div class="col-lg-12 table-responsive">
    <form>
      <table class="w-100 myh_val">
        <tr>
          <td class="tab-border">
            <label>Mortgage Payment</label>
            <h4>${{ mortgagePaymentMonthly | number: '1.0-0' }}</h4>
            <p>&nbsp;</p>
          </td>
          <td class="sign">
            <h4>+</h4>
          </td>
          <td class="tab-border">
            <label>Property Tax</label>
            <ng-container *ngIf="propertyTaxValue != 0; else zeroPropertyTaxValue">
              <h4>${{ propertyTaxValue | toNumber | number: '1.0-0' }}</h4>
            </ng-container>
            <ng-template #zeroPropertyTaxValue>
              <h4>--</h4>
            </ng-template>
            <p>Annual Tax: ${{ propertyTaxValue * 12 | toNumber | number: '1.0-0' }}</p>
          </td>
          <td class="sign">
            <h4>+</h4>
          </td>
          <td class="tab-border myH_proprate">
            <label>Home Insurance </label>

            <ng-container *ngIf="insuranceValue != 0; else zeroInsuranceValue">
              <h4>${{ insuranceValue | toNumber | number: '1.0-0' }}</h4>
            </ng-container>
            <ng-template #zeroInsuranceValue>
              <h4>--</h4>
            </ng-template>
            <p>Annual Insurance: ${{ insuranceValue * 12 | toNumber | number: '1.0-0' }}</p>
          </td>
          <td class="sign">
            <h4>+</h4>
          </td>
          <td class="tab-border myH_proprate" width="12%">
            <label>HOA </label>

            <ng-container *ngIf="hoaFeeValue != 0; else zeroHoaFeeValue">
              <h4>{{ hoaFeeValue | currency: 'USD':'symbol':'0.0-0' }}</h4>
            </ng-container>
            <ng-template #zeroHoaFeeValue>
              <h4>--</h4>
            </ng-template>

            <p>&nbsp;</p>
          </td>
          <td class="sign">
            <h4>=</h4>
          </td>
          <td class="cal-balance">
            <label>Total Monthly Cost</label>
            <h4 class="mb-0">${{ totalPaymentMonthly | toNumber | number: '1.0-0' }}</h4>
            <p>&nbsp;</p>
          </td>
          <td colspan="2">&nbsp;</td>
        </tr>
        <tr>
          &nbsp;
        </tr>
        <tr>
          <td colspan="4">&nbsp;</td>
          <td colspan="3" width="" class="note-txt">
            You may be able to rent this property
            <span *ngIf="!isNegativeOrder(cashFlow)"> at positive cash flow</span>
          </td>
          <td>&nbsp;</td>

          <td class="tab-border myH_proprate" width="12%">
            <label> Monthly Rent </label>
            <ng-container *ngIf="monthlyRent != 0; else nopotentialMonthlyRent">
              <h4>{{ monthlyRent | currency: 'USD':'symbol':'0.0-0' }}</h4>
            </ng-container>
            <ng-template #nopotentialMonthlyRent>
              <h4>--</h4>
            </ng-template>
          </td>

          <td></td>
          <td class="tab-border">
            <label>Monthly Cash Flow</label>
            <h4 class="mb-1" *ngIf="isNegativeOrder(cashFlow)">--</h4>
            <h4 class="mb-1" *ngIf="!isNegativeOrder(cashFlow)">${{ cashFlow | toNumber | number: '1.0-0' }}</h4>
          </td>
        </tr>
      </table>
    </form>
  </div>
</div> -->

<div>
  <div class="">
    <div class="pricing px-4">
      <h3 class="mb-0">{{ savedDealData.name | titlecase }}</h3>
      <div>
        <button class="float-right" mat-icon-button [matMenuTriggerFor]="favMenu" (click)="$event.stopPropagation()">
          <mat-icon>more_vert</mat-icon>
        </button>
        <mat-menu #favMenu="matMenu" id="fldproplist_action" class="mt-0" xPosition="before">
          <button mat-menu-item (click)="navigateToSavedDeal(savedDealData.id, savedDealData.type)">
            <i class="fa fa-arrows-alt pr-2" aria-hidden="true"></i>View Rental Analysis
          </button>
          <button
            mat-menu-item
            (click)="
              deleteDeal(
                savedDealData.id,
                null,
                savedDealData.PMXPropertyId,
                savedDealData.type ? savedDealData.type : null
              )
            "
          >
            <i class="fa fa-trash-o pr-2" aria-hidden="true"></i>Delete
          </button>
        </mat-menu>
      </div>
    </div>

    <div class="mt-3 card-cont">
      <div class="row px-4 mt-3">
        <div class="col-md-6 col-sm-6 col-6">
          <label>Mortgage Payment</label>
        </div>
        <div class="col-md-6 col-sm-6 col-6 value">${{ mortgagePaymentMonthly | number: '1.0-0' }}</div>
      </div>
      <div class="row px-4">
        <div class="col-md-6 col-sm-6 col-6">
          <label>Property Tax</label>
        </div>
        <div class="col-md-6 col-sm-6 col-6 value">
          <ng-container *ngIf="propertyTaxValue != 0; else zeroPropertyTaxValue">
            ${{ propertyTaxValue | toNumber | number: '1.0-0' }}
          </ng-container>
          <ng-template #zeroPropertyTaxValue> -- </ng-template>
        </div>
      </div>
      <div class="row px-4">
        <div class="col-md-6 col-sm-6 col-6">
          <label>Home Insurance</label>
        </div>
        <div class="col-md-6 col-sm-6 col-6 value">
          <ng-container *ngIf="insuranceValue != 0; else zeroInsuranceValue">
            <h4>${{ insuranceValue | toNumber | number: '1.0-0' }}</h4>
          </ng-container>
          <ng-template #zeroInsuranceValue> -- </ng-template>
        </div>
      </div>

      <div class="row px-4">
        <div class="col-md-6 col-sm-6 col-6">
          <label>HOA</label>
        </div>
        <div class="col-md-6 col-sm-6 col-6 value">
          <ng-container *ngIf="hoaFeeValue != 0; else zeroHoaFeeValue">
            {{ hoaFeeValue | currency: 'USD':'symbol':'0.0-0' }}
          </ng-container>
          <ng-template #zeroHoaFeeValue> -- </ng-template>
          <p>&nbsp;</p>
        </div>
      </div>
      <div class="card-section">&nbsp;</div>
      <div class="row px-4 total">
        <div class="col-md-6 col-sm-6 col-6">
          <strong>Total Monthly Cost</strong>
        </div>
        <div class="col-md-6 col-sm-6 col-6 value">
          <strong>${{ totalPaymentMonthly | toNumber | number: '1.0-0' }}</strong>
        </div>
      </div>
      <div class="row px-4 sub-total">
        <div class="col-md-6 col-sm-6 col-6">
          <strong>Monthly Rent</strong>
        </div>
        <div class="col-md-6 col-sm-6 col-6 value">
          <ng-container *ngIf="monthlyRent != 0; else nopotentialMonthlyRent">
            <strong>{{ monthlyRent | currency: 'USD':'symbol':'0.0-0' }}</strong>
          </ng-container>
          <ng-template #nopotentialMonthlyRent>
            <strong>--</strong>
          </ng-template>
        </div>
      </div>
      <div class="row px-4 pb-3 sub-total">
        <div class="col-md-6 col-sm-6 col-6">
          <strong>Monthly Cash Flow</strong>
        </div>
        <div class="col-md-6 col-sm-6 col-6 value">
          <strong class="mb-1" *ngIf="isNegativeOrder(cashFlow)">--</strong>
          <strong class="mb-1" *ngIf="!isNegativeOrder(cashFlow)">${{ cashFlow | toNumber | number: '1.0-0' }}</strong>
        </div>
      </div>
    </div>
  </div>
</div>
